module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-left-top-backplates-remnants.4e76aded.png";